import { useEffect, useState } from "react";
import { Download, Eye, Loader2, X } from "lucide-react";
import { http, downloadBlob } from "../../lib/api";

const kind = (name = "", ct = "") => (/\.pdf$/i.test(name) || ct.includes("pdf") ? "pdf" : /\.(png|jpe?g|webp|gif)$/i.test(name) || ct.startsWith("image/") ? "img" : null);

export const canPreview = (name) => !!kind(name);

export const FilePreview = ({ url, filename, onClose }) => {
  const [src, setSrc] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    let u;
    http.get(url, { responseType: "blob" }).then((r) => { u = URL.createObjectURL(r.data); setSrc({ u, k: kind(filename, r.data.type) }); })
      .catch(() => setErr("No tienes acceso a este archivo o ya no existe"));
    return () => u && URL.revokeObjectURL(u);
  }, [url, filename]);
  return (
    <div className="fixed inset-0 z-[70] flex flex-col bg-[#111]/80 p-3 backdrop-blur-sm sm:p-8" data-testid="file-preview" style={{ animation: "rise .2s ease-out both" }}>
      <div className="mb-3 flex items-center gap-3 text-white">
        <p className="min-w-0 flex-1 truncate text-sm font-semibold">{filename}</p>
        <button onClick={() => downloadBlob(url, filename)} className="inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1.5 text-xs font-semibold hover:bg-white/20" data-testid="file-preview-download"><Download size={13} />Descargar</button>
        <button onClick={onClose} className="rounded-full bg-white/10 p-2 hover:bg-white/20" data-testid="file-preview-close"><X size={16} /></button>
      </div>
      <div className="grid flex-1 place-items-center overflow-hidden rounded-2xl bg-white">
        {err ? <p className="text-sm text-rose-600">{err}</p> : !src ? <Loader2 className="animate-spin text-[#E8643C]" />
          : src.k === "img" ? <img src={src.u} alt={filename} className="max-h-full max-w-full object-contain" data-testid="file-preview-img" />
            : src.k === "pdf" ? <iframe src={src.u} title={filename} className="h-full w-full" data-testid="file-preview-pdf" />
              : <p className="text-sm text-[#5C5850]">Vista previa no disponible; usa Descargar.</p>}
      </div>
    </div>
  );
};

export const PreviewBtn = ({ url, filename, testid }) => {
  const [open, setOpen] = useState(false);
  return (<>
    <button onClick={() => setOpen(true)} className="inline-flex items-center gap-1 font-semibold text-[#5C5850] hover:text-[#E8643C]" data-testid={testid}><Eye size={12} />Ver</button>
    {open && <FilePreview url={url} filename={filename} onClose={() => setOpen(false)} />}
  </>);
};
